<template>
    <div class="bottombar">
        <p class="creato">Creato da <br> <a href="">Denis Paul</a></p>
        <h3>Copyright © 2018 - {{ currentYear }} <br> Tecnoservice snc</h3>
        <div class="links">
            <a href="https://www.iubenda.com/privacy-policy/24009310" class="iubenda-white iubenda-noiframe iubenda-embed" title="Privacy Policy ">Privacy Policy</a>
            <a href="https://www.iubenda.com/privacy-policy/24009310/cookie-policy" class="iubenda-white iubenda-noiframe iubenda-embed" title="Cookie Policy ">Cookie Policy</a>
        </div>
    </div>
</template>


<script>
    export default {
    name: 'BottomBar',
    props: {
        msg: String
    },
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    },
    mounted() {
        const script = document.createElement("script")
        script.src = "https://cdn.iubenda.com/iubenda.js"
        script.async = true
        document.body.appendChild(script);
        const script2 = document.createElement("script")
        script2.src = "https://cdn.iubenda.com/iubenda.js"
        script2.async = true
        document.body.appendChild(script);
  }
    }
</script>

<style lang="scss" scoped>

    .bottombar {
        //Questo serve per mantenere la barra fissa in basso
        position: fixed;
        bottom: 0;

        //Queste righe servono per centrare il testo sia in verticale che in orizzontale
        display: flex;
        justify-content: space-around;
        align-items: center;

        //Colori e dimensioni della barra e dei suoi elementi
        height: 7vh;
        width: 100vw;
        background-color: black;
        color: white; //Questo da il colore agli elementi interni della barra, in questo caso al testo
        font-size: 0.6rem;

        //Serve per non far andare sopra alla barra nessun elemento della pagina
        z-index: 9999; 
    }
    .creato {
        font-size: small;
        a {
            text-decoration: none;
            color: white;
        }
    }

    .links {
        display: flex;
        flex-direction: column;
    }

    @media screen and (max-width: 768px) {
        .bottombar {
            height: 9vh;
        }
    }
</style>
